import React from 'react';
import Table from '../../../../app-components/table/Table';
import {h16_Regular} from '../../../../theme/fonts';
import {getUser} from '../../../../AppServices';
import {h14_AvenirNext} from '../../../../theme/fonts';
import {Text} from '../../../../app-components';

let uri = ({navigation}) => {
  let {state: {params: {item: {_id} = {}} = {}} = {}} = navigation;
  let {organization: {_id: organizationId} = {}} = getUser();
  if (!_id) {
    _id = organizationId;
  }
  return {
    query: {
      id: 'userLists',
      addOnFilter: {
        organization: {_id},
        userType: 'FrontDesk',
      },
    },
    model: 'User',
  };
};

let tableItems = {
  lg: {
    action: ({item}) => {
      return {
        type: 'link',
        link: {
          view: 'edit-FrontDesk',
          params: {item},
        },
      };
    },
    columns: [
      {
        render: (props) => {
          return (
            <Text style={{...h14_AvenirNext, color: 'rgba(56, 56, 56, 0.87)'}}>
              {props.index + 1}
            </Text>
          );
        },
        header: 'S.No.',
        width: 50,
      },
      {
        header: 'Name',
        type: 'text',
        width: 300,
        field: 'name',
        // textStyle: {...h16_Regular},
      },
      {
        header: 'Email',
        type: 'text',
        width: 300,
        field: 'email',
        // textStyle: {...h16_Regular},
      },
      {
        header: 'Mobile Number',
        type: 'text',
        field: 'mobile',
        // textStyle: {...h16_Regular},
      },
      // {
      //   header: 'User Type',
      //   type: 'text',
      //   width: 100,
      //   field: 'userType',
      //   textStyle: {...h16_Regular},
      // },
    ],
  },
  sm: {
    action: ({item}) => {
      return {
        type: 'link',
        link: {
          view: 'edit-FrontDesk',
          params: {item},
        },
      };
    },
    columns: [
      {
        render: (props) => {
          return (
            <Text style={{...h14_AvenirNext, color: 'rgba(56, 56, 56, 0.87)'}}>
              {props.index + 1}
            </Text>
          );
        },
        header: 'S.No.',
        width: 50,
      },
      {
        header: 'Name',
        type: 'text',
        width: 100,
        field: 'name',
      },
      {
        header: 'Email',
        type: 'text',
        width: 100,
        field: 'email',
      },
      {
        header: 'Mobile Number',
        type: 'text',
        field: 'mobile',
        width: 100,

      },
    ],
  },
};
export default Table({
  uri,
  ...tableItems,
  rowHoverContainerStyle: {cursor: 'default'},
  reloadEvent: 'reloadFrontDesk',
});
